import React from "react";

function Freelance() {
  return (
    <div className="">
      <span className="flex justify-center my-8" id="myproject-title">
        My<span id="myproject-title2">Professional</span>{" "}
      </span>

      {/* Resumaid */}
      <div className="flex flex-grow flex-col md:flex-row justify-center items-center mb-12">
        <div className="left-side md:mr-8" id="leftside-background">
          <img src="/images/resumaid.png" alt="resume-enhancer" />
        </div>

        <div className="">
          <h3 className="project-title-text">Resumaid (Alpha)</h3>
          <ul className="flex flex-row  items-center">
            <p className="inline-block mr-3.5" id="made-with">
              Made with:{" "}
            </p>
            <li className="inline-block mr-3.5">
              <span
                class="iconify"
                data-icon="devicon:typescript"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="ri:nextjs-fill"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="logos:tailwindcss-icon"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="skill-icons:supabase-dark"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="simple-icons:clerk"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="logos:stripe"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="logos:vercel"
                data-width="25"
                data-height="25"
              ></span>
            </li>
          </ul>

          <p className="project-description mt-2">
            Designed, developed, and launched Resumaid, a web app that helps job
            seekers quickly generate custom-tailored resumes for any job
            posting. Built with a desktop-first approach using modern web
            technologies, Resumaid focuses on speed, clarity, and relevance,
            enabling users to optimize their resumes in seconds. The tool
            intelligently adapts resumes to match job descriptions, increasing
            the chances of landing interviews. Currently live at resumaid.co,
            with a companion Chrome extension in development for seamless
            LinkedIn integration.
          </p>
          <div className="mt-4">
            <a
              href="https://www.resumaid.co/"
              target="_blank"
              rel="noopener noreferrer"
              id="project-button"
              class="text-white font-bold py-2 px-4 inline-flex items-center mr-2"
            >
              <span class="iconify" data-icon="carbon:new-tab"></span>
              <span>Live</span>
            </a>
          </div>
        </div>
      </div>

      {/* Dulcinella */}
      <div className="flex flex-grow flex-col md:flex-row justify-center items-center mb-12">
        <div className="left-side md:mr-8" id="leftside-background">
          <img src="/images/dulcinella.png" alt="recipe-finder" />
        </div>

        <div className="">
          <h3 className="project-title-text">Dulcinella</h3>
          <ul className="flex flex-row  items-center">
            <p className="inline-block mr-3.5" id="made-with">
              Made with:{" "}
            </p>
            <li className="inline-block mr-3.5">
              <span
                class="iconify"
                data-icon="devicon:typescript"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="ri:nextjs-fill"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="logos:tailwindcss-icon"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                class="iconify"
                data-icon="logos:google-analytics"
                data-width="25"
                data-height="25"
              ></span>
            </li>
          </ul>

          <p className="project-description mt-2">
            Designed, implemented, and hosted the Dulcinella website, a digital
            home for a family-owned bakery in the Beaches, Toronto. Built with
            Next.js, TypeScript, and Tailwind CSS, the site showcases their
            handcrafted cakes and pastries while emphasizing their rich
            traditions and local roots. Featuring a seamless user experience, an
            engaging gallery, and a heartfelt "Our Story" section, the website
            connects the community with the sweet flavors of Dulcinella.
          </p>
          <div className="mt-4">
            <a
              href="http://dulcinella.ca/"
              target="_blank"
              rel="noopener noreferrer"
              id="project-button"
              class="text-white font-bold py-2 px-4 inline-flex items-center mr-2"
            >
              <span class="iconify" data-icon="carbon:new-tab"></span>
              <span>Live</span>
            </a>

            <a
              href="https://www.figma.com/design/gscTZLBKkzihqy6VoYGVuh/Dulcinella?node-id=0-1&t=lMGe7yjNtqa6ftQH-1"
              target="_blank"
              rel="noopener noreferrer"
              id="project-button"
              class="text-white font-bold py-2 px-4 inline-flex items-center mr-2"
            >
              <span class="iconify" data-icon="carbon:new-tab"></span>
              <span>Figma</span>
            </a>
          </div>
        </div>
      </div>


      {/* Resumaid Chrome Extension */}
      <div className="flex flex-grow flex-col md:flex-row justify-center items-center mb-12">
        <div className="left-side md:mr-8" id="leftside-background">
          <img src="/images/chrome-extension.png" alt="chrome-extension" />
        </div>

        <div className="">
          <h3 className="project-title-text">Resumaid Chrome Extension</h3>
          <ul className="flex flex-row items-center">
            <p className="inline-block mr-3.5" id="made-with">
              Made with:{" "}
            </p>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                className="iconify"
                data-icon="vscode-icons:file-type-reactjs"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span
                className="iconify"
                data-icon="devicon:typescript"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                className="iconify"
                data-icon="logos:tailwindcss-icon"
                data-width="25"
                data-height="25"
              ></span>
            </li>
            <li className="inline-block mr-3.5">
              <span></span>
              <span
                className="iconify"
                data-icon="simple-icons:clerk"
                data-width="25"
                data-height="25"
              ></span>
            </li>
          </ul>

          <p className="project-description mt-2">
            Developed a powerful Chrome extension that seamlessly integrates with Resumaid.co,
            enabling users to enhance their resumes directly from job listings. The extension
            uses AI to automatically tailor resumes to match job descriptions, inject relevant
            keywords, and improve match rates. Features include one-click PDF exports with
            ATS-friendly formatting, multiple resume templates, and synchronized credit tracking
            with the main platform. Built with React and TypeScript, the extension offers a
            streamlined experience for job seekers to optimize their applications across
            multiple platforms while maintaining full control over their resume customization.
          </p>
          <div className="mt-4">
            <a
              href="https://chromewebstore.google.com/detail/resumaid/hmkdjkjaeijmbnllngfebjdlpleopogf?authuser=0&hl=en-GB"
              target="_blank"
              rel="noopener noreferrer"
              id="project-button"
              className="text-white font-bold py-2 px-4 inline-flex items-center mr-2"
            >
              <span className="iconify" data-icon="carbon:new-tab"></span>
              <span>Live</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Freelance;
